import { render, staticRenderFns } from "./GuiasImportAsignacion.vue?vue&type=template&id=1b52208f&scoped=true"
import script from "./GuiasImportAsignacion.vue?vue&type=script&lang=js"
export * from "./GuiasImportAsignacion.vue?vue&type=script&lang=js"
import style0 from "./GuiasImportAsignacion.vue?vue&type=style&index=0&id=1b52208f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b52208f",
  null
  
)

export default component.exports